// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Models
import { HolidayStudentList, HolidayStudentFilter, StudentList, StudentFilter, StudentImportResult } from '../models/Student';
import { StudentDetail , StudentScheduleList, StudentScheduleFilter, StudentScheduleImportResult } from '../models/Student';
// Services
import { ApiService} from './ApiService';
import { SettingService } from './SettingService';

@Injectable()
export class StudentService {
    private studentUrl = '/bus-students';
    private holidayStudentUrl = '/hol/student';
    private studentScheduleUrl = '/asa-required-class-children';
    private importStudentScheduleUrl = '/students-schedule'
    private apiUrl = '';

    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    /**
     * 
     */
    getStudents(filter: StudentFilter):Observable<StudentList> {
        let requestUrl = this.apiUrl + this.studentUrl;
        let hasFilter = false;
        
        // Setup filter conditions
        for(let condition in filter) {
            if(filter[condition]){
                if(hasFilter){
                    requestUrl += '&';
                }
                else {
                    requestUrl += '?';
                    hasFilter = true;
                }

                requestUrl += condition + '=' + filter[condition];
            }
        }

        return this.apiService.get<StudentList>(requestUrl);
    }

    getHolidayStudents(holidayStudentFilter: HolidayStudentFilter):Observable<HolidayStudentList> {
        let requestUrl = this.apiUrl + this.holidayStudentUrl;
        let hasFilter = false;
        
        // Setup filter conditions
        for(let condition in holidayStudentFilter) {
            if(holidayStudentFilter[condition]){
                if(hasFilter){
                    requestUrl += '&';
                }
                else {
                    requestUrl += '?';
                    hasFilter = true;
                }

                requestUrl += condition + '=' + holidayStudentFilter[condition];
            }
        }

        return this.apiService.get<HolidayStudentList>(requestUrl);
    }

    getHolidayStudentDetail(studentId: string): Observable<HolidayStudentList> {
        const requestUrl = this.apiUrl + this.holidayStudentUrl + '?id=' + studentId + '&page=1';

        return this.apiService.get<HolidayStudentList>(requestUrl);
    }

    updateHolidayStudentStatus(data: any): Observable<any> {
        const requestUrl = this.apiUrl + this.holidayStudentUrl;

        // Post content
        const body = JSON.stringify(data);

        return this.apiService.patch(requestUrl, body);

    }

    getStudentsSchedule(filter: StudentScheduleFilter):Observable<StudentScheduleList> {
        let requestUrl = this.apiUrl + this.studentScheduleUrl;
        let hasFilter = false;
        
        // Setup filter conditions
        for(let condition in filter) {
            if(filter[condition]){
                if(hasFilter){
                    requestUrl += '&';
                }
                else {
                    requestUrl += '?';
                    hasFilter = true;
                }

                requestUrl += condition + '=' + filter[condition];
            }
        }

        return this.apiService.get<StudentScheduleList>(requestUrl);
    }

    getHolidayStudentInfo(): Observable<HolidayStudentList>{
        let requestUrl = this.apiUrl + this.holidayStudentUrl;
        return this.apiService.get<HolidayStudentList>(requestUrl);
    }

    importStudent(data: FormData): Observable<StudentImportResult> {
        const requestUrl = this.apiUrl + this.studentUrl;

        return this.apiService.patch<StudentImportResult>(requestUrl, data);
    }

    importStudentSchedule(data: FormData): Observable<StudentScheduleImportResult> {
        const requestUrl = this.apiUrl + this.importStudentScheduleUrl;

        return this.apiService.patch<StudentScheduleImportResult>(requestUrl, data);
    }

    updateStudentStatus(studentId:number, data: any): Observable<any> {
        const requestUrl = this.apiUrl + this.studentUrl + "/" + studentId;

        // Post content
        const body = JSON.stringify(data);

        return this.apiService.patch(requestUrl, body);

    }

    // Edit student
    editHolidayStudent(studentDetail: StudentDetail) {
        let requestUrl = this.apiUrl + this.holidayStudentUrl;
        let body = JSON.stringify(studentDetail);
        return this.apiService.patch(requestUrl, body);

    }

    //generate list period with day
    showClassByPeriodAndDay (period:any, weekdays: any[]){
        
        let iWeekdaysLength = weekdays.length;
        let periodCompareName: string;
        for (let i = 0; i < iWeekdaysLength; i++) {
            periodCompareName = `${weekdays[i].period_name} ${weekdays[i].day}`;
            if(_.parseInt(weekdays[i].period_id) === period.id && periodCompareName.toLowerCase() === period.displayName.toLowerCase()){
                return weekdays[i].class || weekdays[i].class_info.name;
            }
        }
        return '';
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/services/StudentService.ts